import { useEffect, useState } from 'react';
import SubmitRequest from './osu/SubmitRequest';
import ConsentCheckbox from './osu/ConsentCheckbox';
import PatientSection from './osu/PatientSection';
import DiseaseSection from './osu/DiseaseSection';
import SubmitToSection from './osu/SubmitToSection';
import { TemplateProps } from './TemplateProps';
import PatientHistorySection from '@/features/requests/components/NewRequest/Templates/osu/PatientHistorySection';
import FormAccordion from '@oncolens/oncolens-ui/lib/components/FormControls/FormAccordion';
import PatientBiomarkerForm from './osu/components/PatientBiomarkerForm';
import TreatmentHistoryForm from './osu/components/TreatmentHistoryForm';
import { without } from 'lodash';
import ReferringProviderSection from './osu/ReferringProviderSection';
import useRequestFormStore from './osu/store';

type AccordionState = 'disease' | 'biomarkers' | 'patientHistory' | 'treatmentHistory' | 'none';

const OsuFormTemplate = ({ template }: TemplateProps) => {
  const { reset } = useRequestFormStore();
  const [accordionState, setAccordionState] = useState<AccordionState[]>(['disease', 'patientHistory', 'treatmentHistory']);
  const setIsOpen = (section: AccordionState) => () =>
    setAccordionState(accordionState.includes(section) ? without(accordionState, section) : [...accordionState, section]);
  const isOpen = (section: AccordionState) => accordionState.includes(section);

  useEffect( () => () => reset(), [ ] );

  return (
    <>
      <SubmitToSection />
      <ReferringProviderSection />
      <PatientSection />
      <FormAccordion
        title="Disease"
        titleId="disease"
        setIsOpen={setIsOpen('disease')}
        isOpen={isOpen('disease')}
      >
        <DiseaseSection />
      </FormAccordion>
      <FormAccordion
        title="Biomarkers"
        titleId="biomarkers"
        setIsOpen={setIsOpen('biomarkers')}
        isOpen={isOpen('biomarkers')}
        useTransition={false}
      >
        <PatientBiomarkerForm />
      </FormAccordion>
      <FormAccordion
        title="Patient History"
        titleId="patientHistory"
        setIsOpen={setIsOpen('patientHistory')}
        isOpen={isOpen('patientHistory')}
      >
        <PatientHistorySection />
      </FormAccordion>
      <FormAccordion
        title="Treatment History"
        titleId="treatmentHistory"
        setIsOpen={setIsOpen('treatmentHistory')}
        isOpen={isOpen('treatmentHistory')}
        useTransition={false}
      >
        <TreatmentHistoryForm />
      </FormAccordion>
      <ConsentCheckbox />
      <SubmitRequest template={template} includeSectionTitle />
    </>
  );
};

export { OsuFormTemplate as default };
